import React from 'react'
import PropTypes from 'prop-types'

import { midas } from '@resurs/midas'
import { Column, Columns } from '@resurs/midas-react'
import { Conditional } from '@resurs/react-utils'

const PaymentMethodsGroup = ({ heading, showHeading, children }) => (
  <Columns>
    <Conditional when={showHeading && !!heading}>
      <Column col12 noPadding>
        <label className={midas.formLabel} style={{ margin: '0 1rem' }}>
          {heading}
        </label>
      </Column>
    </Conditional>
    {children}
  </Columns>
)

PaymentMethodsGroup.propTypes = {
  heading: PropTypes.string,
  showHeading: PropTypes.bool,
  children: PropTypes.node,
}

PaymentMethodsGroup.defaultProps = {
  heading: '',
  showHeading: false,
  children: null,
}

export default PaymentMethodsGroup
